module.exports = __webpack_public_path__ + "img/layout_vertical_icon.ab0f5f6c.svg";